var throttle = require('lodash.throttle')

const _newsScroll = e => {
  let fromTop = window.scrollY + window.innerHeight * 0.75
  let articles = [...document.querySelectorAll('.single-news__main')].reduce(
    (o, x) => {
      o[x.offsetTop + x.offsetHeight] = [
        x.dataset.postSlug,
        x.dataset.postTitle
      ]
      return o
    },
    {}
  )
  let key =
    Object.keys(articles)
      .filter(x => parseFloat(x) >= fromTop)
      .sort()[0] || Object.keys(articles)[Object.keys(articles).length - 1]
  history.replaceState({}, articles[key][1], `/news-events/${articles[key][0]}`)
}

const newsScroll = () => {
  window.__themeArticles = []
  window.addEventListener('scroll', throttle(_newsScroll, 300))
}

export default newsScroll
